//styles
import './body.css';
import 'antd/dist/antd.css';
import "filepond/dist/filepond.min.css";
import '@ant-design/compatible';
import colors from './theme/colors'

import React, {useState, useEffect} from 'react';
import {ApolloProvider} from '@apollo/react-hooks';
import {Layout} from 'antd';
import cubejs from '@cubejs-client/core';
import {CubeProvider} from '@cubejs-client/react';
import WebSocketTransport from '@cubejs-client/ws-transport';
import client from './graphql/client';
import Header from './components/Header';
import {useAuth0} from '@auth0/auth0-react'

import AppContext from './context/AppContext'
import dashboardClient from './utils/dashboardClient'

const getURL = () => {
    if (process.env.REACT_APP_REALTIME === 'true') {
        console.log('realtime app')
        if (process.env.NODE_ENV === 'development') return (process.env.REACT_APP_CUBE_API_DEV).replace('http', 'ws')
        return (process.env.REACT_APP_CUBE_API).replace('https', 'wss')
    }
    console.log('non-realtime app')
    if (process.env.NODE_ENV === 'development') return process.env.REACT_APP_CUBE_API_DEV
    return process.env.REACT_APP_CUBE_API
}

const API_URL = getURL()
// const CUBEJS_TOKEN = process.env.REACT_APP_CUBE_TOKEN;

let apiTokenPromise
const getToken = () => {
    if (!apiTokenPromise) {
        apiTokenPromise = fetch(process.env.REACT_APP_CUBE_TOKENGEN)
            .then((res) => res.json())
            .then((r) => r.token);
    }
    return apiTokenPromise;
}

const cubejsApi = process.env.REACT_APP_REALTIME === 'true' ? cubejs(
    getToken,
    {
        transport: new WebSocketTransport(
            {
                apiUrl: `${API_URL}/`
            }
        )
    }
) : cubejs(
    getToken,
    {
        apiUrl: `${API_URL}/cubejs-api/v1`,
    }
);


const styles = {
    layout: (isAuthenticated) => ({
        height: '100%',
        backgroundColor: !isAuthenticated && colors.SENSIKA
    })
}

const AppLayout = ({children}) => {
    const {isAuthenticated} = useAuth0()
    return (
        <Layout
            style={styles.layout(isAuthenticated)}
        >
            <Header/>
            <Layout.Content>{children}</Layout.Content>
        </Layout>
    )
};

const App = ({children}) => {
    const [update, setUpdate] = useState(false)
    const [allExport, setAllExport] = useState(false)
    const [exportProgress, setExportProgress] = useState({
        progress: 0,
        status: 'normal',
        message: ""
    })

  const [clientName, setClientName] = useState()

  const contextValues = {
    update, setUpdate,
    allExport, setAllExport,
    exportProgress, setExportProgress,
    clientName, setClientName
  }

  useEffect(() => {
    setClientName(dashboardClient.getSelectedClient())
  }, [])

  return (
    <CubeProvider cubejsApi={cubejsApi}>
      <ApolloProvider client={client}>
        <AppContext.Provider value={contextValues}>
          <AppLayout>{children}</AppLayout>
        </AppContext.Provider>
      </ApolloProvider>
    </CubeProvider>
  );
}

export default App;
